



export const closedeniProjects = [
    {
        id:1,
        photoIcon: [
            "./completed/Ongo_14.jpg","./completed/Ongo_14_1.jpg","./completed/Ongo_14_2.jpg","./completed/Ongo_14_3.jpg"
        ],

        client: "BHEL",
        customer:"NMDC",
        location:"NAGARNAR",
        project:""
        
    },
    {
        id:2,
        photoIcon: [
            "./completed/Ongo_15.jpg","./completed/Ongo_15_1.jpg","./completed/Ongo_15_2.jpg","./completed/Ongo_15_3.jpg"
        ],
        client: "TPL",
        customer:"NMD",
        location:"NAGARNAR",
        project:""
    },
    {
        id:3,
        photoIcon: [
            "./completed/Ongo_3.jpg","/completed/Ongo_3_1.jpg","./completed/Ongo_3_2.jpg","./completed/Ongo_3_3.jpg"
        ],
        client: "FL SMIDTH PVT LTD",
        customer:"RELIANCE CEMENT",
        location:"ODISHA",
        project:""
    },
    {
        id:4,
        photoIcon: [
            "./completed/Ongo_4.jpg","/completed/Ongo_4_1.jpg","./completed/Ongo_4_2.jpg","./completed/Ongo_4_3.jpg"
        ],
        client: "L&T Ltd",
        customer:"DALMIA CEMENT LTD",
        location:"BELGUM",
        project:""
    },
    {
        id:5,
        photoIcon: [
            "./completed/Ongo_8.jpg","./completed/Ongo_8_1.jpg","./completed/Ongo_8_2.jpg","./completed/Ongo_8_3.jpg"
        ],
        client: "FL SMIDTH PVT LTD",
        customer:"ROURKELA STEEL PLANT",
        location:"ROURKELA",
        project:""
    },
    {
        id:6,
        photoIcon: [
            "./completed/Compl_26.jpg","./completed/Compl_26_1.jpg","./completed/Compl_26_2.jpg","./completed/Compl_26_3.jpg"
        ],
        client: "MCNALLY",
        customer:"SAIL/RSP",
        location:"ROURKELA",
        project:""
    },
    {
        id:8,
        photoIcon: [
            "./completed/Compl_3.jpg","./completed/Compl_3_1.jpg","./completed/Compl_3_2.jpg","./completed/Compl_3_3.jpg"
        ],
        client: "L&T Ltd (ECC-D), SEPCO",
        customer:"KMPCL",
        location:"NARIYARA",
        project:""
    },
    {
        id:9,
        photoIcon: [
            "./completed/Ongo_10.jpg","./completed/Ongo_10_1.jpg","./completed/Ongo_10_2.jpg","./completed/Ongo_10_3.jpg"
        ],
        client: "ABB Ltd",
        customer:"RSP",
        location:"ROURKELA",
        project:""
    },
    {
        id:10,
        photoIcon: [
            "./completed/Compl_2.jpg","./completed/Compl_2_1.jpg","./completed/Compl_2_2.jpg","./completed/Compl_2_3.jpg"
        ],
        client: "L&T LTD (ECC-D)",
        customer:"GMR LTD",
        location:"VEMAGIRI",
        project:""
    },
    {
        id:11,
        photoIcon: [
            "./completed/Ongo_2.jpg","./completed/Ongo_2_1.jpg","./completed/Ongo_2_2.jpg","./completed/Ongo_2_3.jpg"
        ],
        client: "ABB Ltd",
        customer:"Vedanta Aluminium",
        location:"Jharsuguda",
        project:""
    },
    {
        id:12,
        photoIcon: [
            "./completed/Ongo_11.jpg","./completed/Ongo_11_1.jpg","./completed/Ongo_11_2.jpg","./completed/Ongo_11_3.jpg"
        ],
        client: "ABB Ltd",
        customer:"ISSCO",
        location:"BURNPUR",
        project:""
    },
    {
        id:13,
        photoIcon: [
            "./completed/Compl_4.jpg","./completed/Compl_4_1.jpg","./completed/Compl_4_2.jpg","./completed/Compl_4_3.jpg"
        ],
        client: "ABB Ltd",
        customer:"Grasim Industries Ltd",
        location:" ",
        project:""
    },
    {
        id:14,
        photoIcon: [
            "./completed/Ongo_12.jpg","./completed/Ongo_12_1.jpg","./completed/Ongo_12_2.jpg","./completed/Ongo_12_3.jpg"
        ],
        client: "ABB Ltd",
        customer:"Ultratech Cement Ltd",
        location:"Tadipatri",
        project:""
    },
    {
        id:15,
        photoIcon: [
            "./completed/Compl_0.jpg","./completed/Compl_0_1.jpg","./completed/Compl_0_2.jpg","./completed/Compl_0_3.jpg"
        ],
        client: "VISA STEEL ",
        customer:"VISA STEEL",
        location:"JAIPUR",
        project:""
    },
    {
        id:16,
        photoIcon: [
            "./completed/Compl_1.jpg","./completed/Compl_1_1.jpg","./completed/Compl_1_2.jpg","./completed/Compl_1_3.jpg"
        ],
        client: "Abhijeet Projects Ltd",
        customer:"Corporate Ispat Alloy Ltd",
        location:"Sarikala",
        project:""
    },
    {
        id:17,
        photoIcon: [
            "./completed/Compl_7.jpg","./completed/Compl_7_1.jpg","./completed/Compl_7_2.jpg","./completed/Compl_7_3.jpg"
        ],
        client: "VISA STEEL",
        customer:"VISA STEEL",
        location:"Jaipur, Odhisa",
        project:""
    },
    {
        id:18,
        photoIcon: [
            "./completed/Compl_12.jpg","./completed/Compl_12_1.jpg","./completed/Compl_12_2.jpg","./completed/Compl_12_3.jpg"
        ],
        client: "KWPCL ",
        customer:"KWPCL",
        location:"",
        project:""
    },
    {
        id:19,
        photoIcon: [
            "./ongoing/Ongo_14.jpg", "./ongoing/Ongo_14_1.jpg","./ongoing/Ongo_14_2.jpg","./ongoing/Ongo_14_3.jpg"
        ],
        client: "BHEL",
        customer:"NMDC",
        location:"NAGARNAR",
        project:"EQUIPMENT ERECTION AND LT CABLE LAYING WORKS FOR NMDC PPDS PKG NAGARNAR"
    },
    {
        id:20,
        photoIcon: [
            "./ongoing/Ongo_15.jpg", "./ongoing/Ongo_15_1.jpg","./ongoing/Ongo_15_2.jpg","./ongoing/Ongo_15_3.jpg"
        ],
        client: "TPL",
        customer:"NMDC",
        location:"",
        project: "ERECTION SERVICE FOR NMDC BLAST FURNACE NAGARNAR PROJECT"
    },
    {
        id:21,
        photoIcon: [
            "./ongoing/Ongo_16.jpg", "./ongoing/Ongo_16_1.jpg","./ongoing/Ongo_16_2.jpg","./ongoing/Ongo_16_3.jpg"
        ],
        client: "NRDA",
        customer:"NRDA",
        location:"RAIPUR",
        project:"SUPPLY, INSTALLATION, TESTING AND COMMISSIONING OF HT/LT DISTRIBUTION SYSTEM FOR HEALTH AND WATER RESOURCE DEPARTMENT BUILDING AT NAYA RAIPUR"
    },
    {
        id:22,
        photoIcon: [
            "./ongoing/Ongo_20.jpg", "./ongoing/Ongo_20_1.jpg","./ongoing/Ongo_20_2.jpg","./ongoing/Ongo_20_3.jpg"
        ],
        client: "UTCL",
        customer:"UTCL",
        location:"DANKUNI",
        project:"E&I ERECTION PACKAGE AT UTCL DANKUNI CEMENT WORK, DANKUNI."
    },
    {
        id:23,
        photoIcon: [
            "./ongoing/Ongo_0.jpg", "./ongoing/Ongo_0_1.jpg","./ongoing/Ongo_0_2.jpg","./ongoing/Ongo_0_3.jpg"
        ],
        client: "MECON LTD",
        customer:"BOKARO STEEL PLANT",
        location:"BOKARO",
        project: "REBUILDING OF COKE OVEN BATTERY #7, SUPPLY, ERECTION, TESTING & COMMISSIONING OF ELECTRICAL PLANT & EQUIPMENT (PKG- SE-831)."
    },
    {
        id:24,
        photoIcon: [
            "./ongoing/Ongo_21.jpg", "./ongoing/Ongo_21_1.jpg","./ongoing/Ongo_21_2.jpg","./ongoing/Ongo_21_3.jpg"
        ],
        client: "SIEMESNS",
        customer:"SAIL",
        location:"BHILAI",
        project:"ELECTRICAL INSTALLATION JOB FOR BSP CCP&BOF PACKAGE, BHILAI"
    },
    {
        id:25,
        photoIcon: [
            "./ongoing/Ongo_9.jpg", "./ongoing/Ongo_9_1.jpg","./ongoing/Ongo_9_2.jpg","./ongoing/Ongo_9_3.jpg"
        ],
        client: "ABB INDIA LTD",
        customer:"SAIL",
        location:"BHILAI",
        project:"ELECTRICAL INSTALLATION WORK OF 71(A) PROJECT, BSP, BHILAI."

    },
    {
        id:26,
        photoIcon: [
            "./ongoing/Ongo_6.jpg", "./ongoing/Ongo_6_1.jpg","./ongoing/Ongo_6_2.jpg","./ongoing/Ongo_6_3.jpg"
        ],
        client: "BIDCO LTD",
        customer:"ALSTOM T&D INDIA LTD",
        location:"",
        project:"PLANT ILLUMINATION AND PANEL ERECTION WORK FOR BIDCO LALITPUR E-BOP PACKAGE."
    },
    {
        id:27,
        photoIcon: [
            "./ongoing/Ongo_5.jpg", "./ongoing/Ongo_5_1.jpg","./ongoing/Ongo_5_2.jpg","./ongoing/Ongo_5_3.jpg"
        ],
        client: "MECON LTD ",
        customer:"SAIL",
        location:"BHILAI",
        project:"TURNKEY EPC PROJECT OF ELECTRICAL & INSTRUMENTATION OF COLD REPAIR COKE OVEN BATTERY#9"
    },
    {
        id:28,
        photoIcon: [
            "./ongoing/Ongo_23.jpg", "./ongoing/Ongo_23_1.jpg","./ongoing/Ongo_23_2.jpg","./ongoing/Ongo_23_3.jpg"
        ],
        client: "FL SMIDTH",
        customer:"SAIL",
        location:"BHILAI",
        project:"ELECTRICAL INSTALLATION WORK PIPE CONVEYOR PROJECT,BHILAI."
    },
    {
        id:29,
        photoIcon: [
            "./ongoing/Ongo_1.jpg", "./ongoing/Ongo_1_1.jpg","./ongoing/Ongo_1_2.jpg","./ongoing/Ongo_1_3.jpg"
        ],
        client: "ABHIJEET PROJECTS LTD",
        customer:"ABHIJEET INFRASTRUCTURE LTD",
        location:"SERAIKELA",
        project:"2X500TPD DRI & 2X30MW CPP:- ELECTRICAL INSTALLATION INCLUDING SUPPLY OF LIGHTING MATERIALS & MISC. ITEMS."
    },
    {
        id:30,
        photoIcon: [
            "./ongoing/Ongo_1.jpg", "./ongoing/Ongo_1_1.jpg","./ongoing/Ongo_1_2.jpg","./ongoing/Ongo_1_3.jpg"
        ],
        client: "ULTRATECH CEMENT LTD",
        customer:"ULTRATECH CEMENT LTD",
        location:"DANKUNI",
        project:"Erection, Testing & Commissioning Support Services of Electrical & Instrumentation for Grinding Unit at Dankuni (WB)"
    },
]